// Partner-only marks hosted on the static CDN (4x exports of the Figma partner
// frames); the image loader appends its own width/quality/format.
export const PASS_PARTNER_LOGOS = [
  {
    name: 'Navy SEAL Foundation',
    src: 'https://static.masterclass.com/NSF-LogoOnly.png',
    width: 335,
    height: 120,
  },
  {
    name: 'Microsoft',
    src: 'https://static.masterclass.com/MSFT-LogoOnly.png',
    width: 319,
    height: 120,
  },
  {
    name: 'Uber',
    src: 'https://static.masterclass.com/Uber-LogoOnly.png',
    width: 210,
    height: 120,
  },
  {
    name: 'X, The Moonshot Factory',
    src: 'https://static.masterclass.com/MOON-LogoOnly.png',
    width: 329,
    height: 120,
  },
] as const

export const PASS_PARTNER_LOGO_HEIGHT = 30
